function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var globals = {
  isInitialized: false,
  isAppcuesInitialized: false,
  isMunchkinInitialized: false,
  deferredCalls: [],
  PA_ENV: 'PROD',
  env: function env() {
    return window.PA_ENV || this.PA_ENV;
  },
  debug_session: function debug_session() {
    return window.PA_DEBUG_SESSION || false;
  },
  orwellHost: function orwellHost() {
    if ('PROD' == this.env().toUpperCase()) {
      return 'https://orwell.podium.com';
    } else {
      return window.PA_ORWELL_HOST || 'http://localhost:2002';
    }
  },
  magicHost: function magicHost() {
    if ('PROD' == this.env().toUpperCase()) {
      return 'https://magic.podium.com';
    } else {
      return window.PA_MAGIC_HOST || 'http://localhost:3232';
    }
  },
  munchkinId: function munchkinId() {
    if ('PROD' == this.env().toUpperCase()) {
      return '841-BRM-380';
    } else {
      return window.PA_MUNCHKIN_ID || '805-RXS-474';
    }
  }
};

var name="@podiumhq/podium-analytica";var version="2.1.19";

function getInfo() {
  return {
    libraryVersion: version,
    libraryName: name,
    pageReferrer: document.referrer,
    pageTitle: document.title
  };
}

var session = {
  getInfo: getInfo
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var PODIUM_ANALYTICS_COOKIE = 'pa_user';
var PODIUM_ANALYTICS_USER_ID = PODIUM_ANALYTICS_COOKIE + '_id';
var PODIUM_ANALYTICS_USER_UID = PODIUM_ANALYTICS_COOKIE + '_uid';

var MUNCHKIN_NAME = 'munchkin';
var APPCUES_NAME = 'appcues';
var stack = [];

function is_munchkin_loaded() {
  return is_third_party_script_loaded({
    name: MUNCHKIN_NAME,
    obj: window.Munchkin
  });
}

function is_appcues_loaded() {
  return is_third_party_script_loaded({
    name: APPCUES_NAME,
    obj: window.Appcues
  });
}

function is_third_party_script_loaded() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      obj = _ref.obj;

  if (obj) {
    return true;
  } else {
    /* eslint-disable-next-line no-console */
    console.warn("[podium-analytica] ".concat(name, " was blocked from being loaded")); // TODO: This needs to post to orwell, but we can not use af.track
    // because it creates a circular dependency

    return false;
  }
}

function append(args) {
  // make sure we don't get any token cookies
  var all_cookies = document.cookie.replace(/(token)=[^;]+/gi, '$1=CENSORED').split(';').map(function (cookie) {
    return cookie.trim();
  }); // only capture the whitelisted cookies

  var white_listed_keys = [PODIUM_ANALYTICS_COOKIE, PODIUM_ANALYTICS_USER_ID, PODIUM_ANALYTICS_USER_UID];
  var local = white_listed_keys.map(function (key) {
    var value = window.localStorage.getItem(key);
    return value ? "".concat(key, "=").concat(value) : '';
  }).join('; ');
  var cookies = all_cookies.reduce(function (acc, cur) {
    var key = cur.split('=')[0] || '';

    if (white_listed_keys.includes(key)) {
      acc.push(cur);
    }

    return acc;
  }, []).join('; ');
  var meta = {
    i: stack.length,
    at: new Date(),
    libraryVersion: version
  };

  var enriched = _objectSpread2(_objectSpread2(_objectSpread2({}, meta), args), {}, {
    cookies: cookies,
    local: local
  });

  stack.push(enriched);
}

var debug = {
  is_munchkin_loaded: is_munchkin_loaded,
  is_appcues_loaded: is_appcues_loaded,
  append: append,
  stack: stack
};

var TEN_YEARS = 60 * 60 * 1000 * 24 * 365 * 10;
var ID_TOKEN_KEY = 'idToken';

function setCookieIfNotSet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value;

  if (!getCookie(name)) {
    setCookie({
      name: name,
      value: value
    });
  }
}

function getCookie(name) {
  return document.cookie.split(';').map(function (cookie) {
    return cookie.trim();
  }).filter(function (cookie) {
    return cookie.includes("".concat(name, "="));
  }).map(function (cookie) {
    return cookie.substring("".concat(name, "=").length, cookie.length);
  }).shift() || null;
}

function eraseCookie(name) {
  document.cookie = "".concat(name, "=; Max-Age=-99999999;");
}

function getIdToken() {
  var token = getCookie(ID_TOKEN_KEY);
  if (!token) throw 'no idToken cookie';
  if (isExpired(token)) throw 'idToken is expired';
  return token;
} // private functions


function setCookie() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref2.name,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? '' : _ref2$value;

  var expires = new Date();
  expires.setTime(expires.getTime() + TEN_YEARS);
  document.cookie = "".concat(name, "=").concat(encodeURIComponent(value), ";expires=").concat(expires.toUTCString(), ";domain=").concat(getTopDomain(), ";");

  if (!getCookie(name)) {
    var msg = "could not set \"".concat(name, "\" cookie");
    /* eslint-disable-next-line no-console */

    console.error(msg);
    debug.append({
      func: 'orwell.setCookie',
      msg: msg
    });
  }
}

function getTopDomain() {
  if (window.location.hostname === 'localhost') {
    return window.location.hostname;
  }

  var cookieName = 'temporary';
  var cookie = "".concat(cookieName, "=fake");
  var domainParts = document.location.hostname.split('.');

  for (var i = domainParts.length - 2; i >= 0; i--) {
    var domain = domainParts.slice(i).join('.'); // try and set a temporary cookie for the given domain
    // (except for the last part which is usually going to be "com")

    document.cookie = "".concat(cookie, ";domain=.").concat(domain, ";"); // check if the cookie was actually set for the given domain

    if (document.cookie.indexOf(cookie) > -1) {
      // delete temporary fake cookie
      eraseCookie(cookieName);
      return ".".concat(domain);
    }
  }
}

function isExpired(idToken) {
  var decodedToken = decodeToken(idToken);
  var date = decodedToken.exp ? decodedToken.exp : null; // convert to millis

  return new Date(date * 1000) < Date.now();
}

function decodeToken(idToken) {
  if (idToken) {
    var tokenParts = idToken.split('.');
    return JSON.parse(atob(tokenParts[1]));
  }

  throw 'Could not decode jwt';
}

var cookies = {
  setCookieIfNotSet: setCookieIfNotSet,
  setCookie: setCookie,
  getCookie: getCookie,
  eraseCookie: eraseCookie,
  getIdToken: getIdToken
};

function init$1() {
  var anonymous_id = generateAnonymousUserId();
  cookies.setCookieIfNotSet({
    name: PODIUM_ANALYTICS_COOKIE,
    value: anonymous_id
  }); // set if not set for localstorage

  var value = window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE) || anonymous_id;
  window.localStorage.setItem(PODIUM_ANALYTICS_COOKIE, value);
  debug.append({
    func: 'orwell.init'
  });
}

function track$1(_ref) {
  var eventName = _ref.eventName,
      payload = _ref.payload;
  payload.event = eventName;
  debug.append({
    func: 'orwell.track',
    event: eventName
  });

  if (globals.debug_session()) {
    payload.stacktrace = JSON.stringify(debug.stack);
  }

  var options = {
    method: 'POST',
    headers: [['Content-Type', 'application/json']],
    body: JSON.stringify(payload)
  };
  return fetch("".concat(globals.orwellHost(), "/api/v1/events"), options);
}

function page$1(_ref2) {
  var pageName = _ref2.pageName,
      payload = _ref2.payload;
  payload.page = pageName;
  debug.append({
    func: 'orwell.page',
    page: pageName
  });

  if (payload.page) {
    return track$1({
      eventName: pageName,
      payload: payload
    });
  } else {
    return track$1({
      eventName: 'page-view.no-page-name',
      payload: payload
    });
  }
}

function identify$1(user) {
  var _user$id = user.id,
      id = _user$id === void 0 ? cookies.getCookie(PODIUM_ANALYTICS_COOKIE) : _user$id,
      _user$uid = user.uid,
      uid = _user$uid === void 0 ? cookies.getCookie(PODIUM_ANALYTICS_COOKIE) : _user$uid;
  cookies.setCookie({
    name: PODIUM_ANALYTICS_USER_ID,
    value: id
  });
  cookies.setCookie({
    name: PODIUM_ANALYTICS_USER_UID,
    value: uid
  });
  window.localStorage.setItem(PODIUM_ANALYTICS_USER_ID, id);
  window.localStorage.setItem(PODIUM_ANALYTICS_USER_UID, uid);

  var meta = _objectSpread2({}, user);

  delete meta.id;
  delete meta.uid;

  var payload = _objectSpread2(_objectSpread2({
    meta: meta
  }, getUserCookies()), {}, {
    appName: 'Web App',
    session: session.getInfo(),
    identify: true
  });

  var options = {
    method: 'POST',
    headers: [['Content-Type', 'application/json']],
    body: JSON.stringify(payload)
  };
  debug.append({
    func: 'orwell.identify'
  });

  if (globals.debug_session()) {
    payload.stacktrace = JSON.stringify(debug.stack);
  }

  return fetch("".concat(globals.orwellHost(), "/api/v1/events"), options);
}

function reset$1() {
  cookies.eraseCookie(PODIUM_ANALYTICS_COOKIE);
  cookies.eraseCookie(PODIUM_ANALYTICS_USER_ID);
  cookies.eraseCookie(PODIUM_ANALYTICS_USER_UID); // localstorage

  window.localStorage.removeItem(PODIUM_ANALYTICS_COOKIE);
  window.localStorage.removeItem(PODIUM_ANALYTICS_USER_ID);
  window.localStorage.removeItem(PODIUM_ANALYTICS_USER_UID);
  debug.append({
    func: 'orwell.reset'
  });
  init$1();
}

function getUserCookies() {
  // validate that cookie and localStorage is the same.
  // If they are not, then add the values to debug stacktrace
  var is_invalid = [cookies.getCookie(PODIUM_ANALYTICS_COOKIE) === window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE), cookies.getCookie(PODIUM_ANALYTICS_USER_ID) === window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID), cookies.getCookie(PODIUM_ANALYTICS_USER_UID) === window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)].includes(false);

  if (is_invalid) {
    var _values;

    var values = (_values = {}, _defineProperty(_values, PODIUM_ANALYTICS_COOKIE, cookies.getCookie(PODIUM_ANALYTICS_COOKIE)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_COOKIE), window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE)), _defineProperty(_values, PODIUM_ANALYTICS_USER_ID, cookies.getCookie(PODIUM_ANALYTICS_USER_ID)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_USER_ID), window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID)), _defineProperty(_values, PODIUM_ANALYTICS_USER_UID, cookies.getCookie(PODIUM_ANALYTICS_USER_UID)), _defineProperty(_values, "LS_".concat(PODIUM_ANALYTICS_USER_UID), window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)), _defineProperty(_values, "ALL_COOKIES", document.cookie.replace(/(token)=[^;]+/gi, '$1=CENSORED').split(';').map(function (cookie) {
      return cookie.trim();
    })), _values);
    debug.append({
      func: 'orwell.getUserCookies',
      values: values
    });
  }

  return {
    anonymous_user: cookies.getCookie(PODIUM_ANALYTICS_COOKIE) || window.localStorage.getItem(PODIUM_ANALYTICS_COOKIE),
    user_id: cookies.getCookie(PODIUM_ANALYTICS_USER_ID) || window.localStorage.getItem(PODIUM_ANALYTICS_USER_ID),
    user_uid: cookies.getCookie(PODIUM_ANALYTICS_USER_UID) || window.localStorage.getItem(PODIUM_ANALYTICS_USER_UID)
  };
} // Private functions


function generateAnonymousUserId() {
  return v4();
}

var af = {
  init: init$1,
  track: track$1,
  identify: identify$1,
  reset: reset$1,
  getUserCookies: getUserCookies,
  page: page$1
};

function page(pageName, locationUid, meta) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.page()', pageName, locationUid, meta);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'page',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.page call');
    return;
  }

  meta = _objectSpread2(_objectSpread2({}, meta), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2({
    appName: 'Web App',
    currentLocationUid: locationUid
  }, meta);

  af.page({
    pageName: pageName,
    payload: _objectSpread2(_objectSpread2(_objectSpread2({}, payload), af.getUserCookies()), {}, {
      session: session.getInfo(),
      meta: meta
    })
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.page();
  }

  if (debug.is_munchkin_loaded()) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: pageName,
      params: "s=".concat(JSON.stringify(payload))
    });
  }
}

function track(event) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.track()', event, meta);

  if (!event) {
    // eslint-disable-next-line no-console
    console.warn('[podium-analytica] 👆Undefined track event. Check to make sure that your event is defined in podium-analytica and called properly in your app');
    return;
  }

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'track',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.track call');
    return;
  }

  meta = _objectSpread2(_objectSpread2({}, meta), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2(_objectSpread2({}, meta), {}, {
    appName: 'Web App'
  }, event);

  var eventName = "".concat(event.context, ".").concat(event.feature);
  af.track({
    eventName: eventName,
    payload: _objectSpread2(_objectSpread2({}, af.getUserCookies()), {}, {
      meta: meta,
      appName: 'Web App',
      session: session.getInfo()
    }, event)
  }).catch(function (error) {
    /* eslint-disable-next-line no-console */
    console.error('could not call animal-farm.track', error);
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.track("".concat(eventName, ".").concat(event.action), payload);
  }

  if (debug.is_munchkin_loaded()) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: " - ".concat(eventName, ".").concat(event.action),
      params: "s=".concat(JSON.stringify(payload))
    });
  }
}
function UNSAFE_track(data, eventName) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.UNSAFE_track()', data, eventName);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'UNSAFE_track',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.UNSAFE_track call');
    return;
  }

  data = _objectSpread2(_objectSpread2({}, data), {}, {
    afSyncUID: v4()
  });

  var payload = _objectSpread2({
    appName: 'Web App'
  }, data);

  af.track({
    eventName: eventName,
    payload: _objectSpread2(_objectSpread2({
      deprecated: true
    }, af.getUserCookies()), {}, {
      meta: data,
      appName: 'Web App',
      session: session.getInfo()
    })
  }).catch(function (error) {
    /* eslint-disable-next-line no-console */
    console.error('could not call animal-farm.track (from UNSAFE_track)', error);
  });

  if (debug.is_appcues_loaded()) {
    window.Appcues.track(eventName, payload);
  }
}

function show(id) {
  // eslint-disable-next-line no-console
  console.debug('[podium-analytica] Called analytics.show()', id);

  if (!globals.isInitialized) {
    globals.deferredCalls.push({
      method: 'show',
      args: arguments
    }); // eslint-disable-next-line no-console

    console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.show call');
    return;
  }

  if (debug.is_appcues_loaded()) {
    window.Appcues.show(id);
  }
}

var _excluded = ["id"];
function identify(_x) {
  return _identify.apply(this, arguments);
}

function _identify() {
  _identify = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
    var id,
        other,
        data,
        msg,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // eslint-disable-next-line no-console
            console.debug('[podium-analytica] Called analytics.identify()', user);

            if (globals.isInitialized) {
              _context.next = 5;
              break;
            }

            globals.deferredCalls.push({
              method: 'identify',
              args: _args
            }); // eslint-disable-next-line no-console

            console.debug('[podium-analytica] third party scripts are not done loading. Enqueuing analytics.identify call');
            return _context.abrupt("return");

          case 5:
            af.identify(user);
            id = user.id, other = _objectWithoutProperties(user, _excluded);

            if (debug.is_appcues_loaded()) {
              window.Appcues.identify(id, other); // direct to appcues
            }

            _context.prev = 8;
            _context.next = 11;
            return fetchMunchkinKey(user);

          case 11:
            data = _context.sent;

            if (debug.is_munchkin_loaded()) {
              window.Munchkin.munchkinFunction('associateLead', {
                Email: user.email
              }, data.munchkinKey);
            }

            _context.next = 20;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](8);
            msg = '[podium-analytica] Error fetching Munchkin key from Magic'; // eslint-disable-next-line no-console

            console.warn(msg, _context.t0);
            debug.append({
              func: 'orwell.identify',
              error: "".concat(msg, ". Error: ").concat(_context.t0)
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 15]]);
  }));
  return _identify.apply(this, arguments);
}

function fetchMunchkinKey(_x2) {
  return _fetchMunchkinKey.apply(this, arguments);
}

function _fetchMunchkinKey() {
  _fetchMunchkinKey = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(user) {
    var query, variables, idToken, response, _yield$response$json, data;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // ask magic what the munchkinKey is
            query = "\n    query munchkinKey($email: String!) {\n      munchkinKey(email: $email)\n    }\n  ";
            variables = {
              email: user.email
            };
            idToken = cookies.getIdToken();
            _context2.next = 5;
            return fetch("".concat(globals.magicHost(), "/graphql"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Authorization: "Bearer ".concat(idToken)
              },
              body: JSON.stringify({
                query: query,
                variables: variables
              })
            });

          case 5:
            response = _context2.sent;
            _context2.next = 8;
            return response.json();

          case 8:
            _yield$response$json = _context2.sent;
            data = _yield$response$json.data;
            return _context2.abrupt("return", data);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchMunchkinKey.apply(this, arguments);
}

var publicApiMap = {
  identify: identify,
  page: page,
  UNSAFE_track: UNSAFE_track,
  track: track,
  show: show
};
function init() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$PA_ENV = _ref.PA_ENV,
      PA_ENV = _ref$PA_ENV === void 0 ? 'PROD' : _ref$PA_ENV;

  globals.PA_ENV = PA_ENV; // eslint-disable-next-line no-console

  console.debug("[podium-analytica] PA_ENV=".concat(globals.env(), ".\n      Remove 'Verbose' from your console log levels to hide debug logs."));
  af.init();
  loadAppcues();
  loadMunchkin();
}

var loadAppcues = function loadAppcues() {
  loadScript('//fast.appcues.com/26740.js', initAppcues);
};

var initAppcues = function initAppcues() {
  if (globals.isAppcuesInitialized === false) {
    globals.isAppcuesInitialized = true;
    flushCalls();
  }
};

function loadMunchkin() {
  loadScript('//munchkin.marketo.net/munchkin.js', initMunchkin.bind(null));
}

function initMunchkin() {
  if (globals.isMunchkinInitialized === false) {
    globals.isMunchkinInitialized = true;

    if (debug.is_munchkin_loaded()) {
      window.Munchkin.init(globals.munchkinId(), {
        apiOnly: true
      });
    }

    flushCalls();
  }
}

function flushCalls() {
  if (globals.isMunchkinInitialized && globals.isAppcuesInitialized) {
    globals.isInitialized = true; // eslint-disable-next-line no-console

    console.debug("[podium-analytica] All third party scripts are done loading. Executing queued calls. ".concat(globals.deferredCalls.length, " calls in queue")); // Make sure that all 'identify' calls are on the list

    var queue = globals.deferredCalls.reduce(function (acc, cur) {
      cur.method === 'identify' ? acc.unshift(cur) : acc.push(cur);
      return acc;
    }, []);
    /* eslint-disable-next-line no-console */

    console.log('[podium-analytica] Flushing queued calls.');
    queue.map(function (call, i) {
      /* eslint-disable-next-line no-console */
      console.log("[podium-analytica][".concat(i, "]: ").concat(call.method));
    });

    while (queue.length) {
      var call = queue.shift();
      var args = call.args;

      if (publicApiMap[call.method]) {
        publicApiMap[call.method].apply(publicApiMap, _toConsumableArray(args));
      } else {
        // eslint-disable-next-line no-console
        console.warn('[podium-analytica] Unsupported analytic call', call);
      }
    } // eslint-disable-next-line no-console


    console.debug("[podium-analytica] Queued calls have been executed. ".concat(queue.length, " calls in queue"));
  }
}

function loadScript(srcUrl, onFinish) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = srcUrl;

  script.onreadystatechange = function () {
    if (this.readyState == 'complete' || this.readyState == 'loaded') {
      onFinish();
    }
  };

  script.onload = onFinish;
  script.onerror = onFinish;
  document.getElementsByTagName('head')[0].appendChild(script);
}

var MUNCHKIN_COOKIE_NAME = '_mkto_trk';
function reset() {
  if (!globals.isInitialized) {
    return;
  }

  if (debug.is_appcues_loaded()) {
    window.Appcues.reset();
  }

  af.reset();
  cookies.eraseCookie(MUNCHKIN_COOKIE_NAME);
}

var index = {
  init: init,
  page: page,
  track: track,
  UNSAFE_track: UNSAFE_track,
  identify: identify,
  reset: reset,
  show: show
};

export { index as default };
